<template>
<div class="navbar">
    <div class="lt-side">
        
        <div class="menu-wrap-2">
          <div class="links-wrap">
            <small class="link button-text"><span @click="toggleMenu()">Menu</span></small>
          </div>
          <div v-if="this.$store.state.activePage === 'feed'" class="logo-wrap" @click="scrollToTop" @mouseover="logoHover" @mouseleave="logoHoverYes = false">
            <IconLogo class="icon-logo" :logohover="logoHoverYes" />
          </div>
          <div v-else class="logo-wrap">
            <router-link to="/">
              <IconLogo class="icon-logo" />
            </router-link>
          </div>
        </div>

    </div>
    <div class="rt-side">

        <div class="links-wrap">
          <div class="links-lt">
            
              <small class="link button-text">
                <router-link to="/">
                  <span :class="{ dotbefore: $store.state.activePage === 'feed' }">Feed</span>
                </router-link>
              </small>
            
            <small class="link button-text"><span @click="togglePopMess('Rankings are coming soon')">Rankings</span></small>
            <small class="link button-text"><span @click="toggleAbout()">About</span></small>
          </div>
          <div class="links-rt">
            <small class="link button-text"><span @click="togglePopMess('Search are coming soon')">Search</span></small>
          </div>
        </div>

    </div>
</div>

</template>

<script>
import { db, auth } from '../db'
import IconMenu from '../assets/icons/IconMenu.vue'
import IconSearch from '../assets/icons/IconSearch.vue'
import IconLogo from '../assets/icons/IconLogo.vue'

export default {
  name: 'Navbar',
  props: [
    "userinfo"
  ],
  components: {
    IconMenu,
    IconSearch,
    IconLogo
  },
  data() {
    return {
      email: '',
      password: '',
      logoHoverYes: false,
    }
  },
  methods: {
    signIn() {
      auth.signInWithEmailAndPassword(this.email, this.password)
      .then(() => {
          console.log(`Logged in`)
      }).catch(err => {console.log(err.message)})
    },
    signUp() {
      auth.createUserWithEmailAndPassword(this.email, this.password)
      .then(e => {
          return db.collection('users').doc(e.user.uid).set({
            uid: e.user.uid,
            firstname: this.firstname,
            lastname: this.lastname,
            email: e.user.email,
            pic: ''
          })
          // Update profile gick bara att köra separat, men det är ändå bra för att den kommer behöva kallas separat när man behöver uppdatera nåt ändå
          // return this.updateProfile()
      })
      .then(() => {
        console.log('Account created')
      })
      .catch(err => {console.log(err.message)})
    },
    signOut() {
      auth.signOut()
        .then(() => {
            console.log(`Signed out`)
        }).catch(err => {console.log(err.message)})
    },
    updateProfile() {
      if (this.firstname && this.lastname) {
        db.collection('users').doc(auth.currentUser.uid)
        .set({
            firstname: this.firstname,
            lastname: this.lastname,
        },{merge:true})
        .then(() => {
          console.log('Profile updated')
        }).catch(err => {console.log(err.message)})
      } else {
        alert('Name fields are empty')
      }
    },
    deleteUser() {
      auth.currentUser.delete().then(function() {
        console.log('User deleted.')
      }).catch(function(error) {
        console.log(error.message)
      });
    },
    toggleMenu() {
      this.$store.commit('toggleMenu')
    },
    toggleAbout(payload) {
      this.$store.commit('toggleAbout', payload)
    },
    toggleCreatePost() {
      this.$store.commit('toggleCreatePost')
    },
    toggleLogin(payload) {
      this.$store.commit('toggleLogin', payload)
    },
    showSignUp(payload) {
      this.$store.commit('showSignUp', payload)
    },
    togglePopMess(payload) {
      this.$store.commit('togglePopMess', payload)
    },
    logoHover() {
      if (window.pageYOffset != 0 && !window.matchMedia("(max-width: 700px)").matches) {
        return this.logoHoverYes = true
      } else {
        return this.logoHoverYes = false
      }
    },
    scrollToTop() {
        window.scrollTo({
          top: 0, 
          left: 0, 
          behavior: 'smooth'
        });
    }

  }
}
</script>
<style lang="scss" scoped>
// @import "../scss/_variables.scss";

.navbar {
  position: fixed;
  width: 100vw;
  display: flex;
  align-items: center;
  // justify-content: space-between;
  background-color: $white;
  z-index: 10;
  // border-bottom: $line-bold solid $line-color-dark;
  height: $nav-height;
  & > * {
    display: flex;
    align-items: center;
  }
  .signed-in, .signed-out {
      display: flex;
      align-items: center;
  }
  .menu-wrap, .search-wrap {
      width: $grid-padding;
      font-weight: $bold;
  }
  .menu-wrap {
    height: 100%;
    .menu-icon {
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
  .search-wrap {
      display: flex;
      justify-content: flex-end;
      height: 100%;
      .search-icon {
        height: 100%;
        display: flex;
        align-items: center;
      }
  }

  .lt-side {
    .menu-wrap-2 {
      margin-left: $grid-padding;
      margin-right: $main-margin;
      width: $col6;
      display: flex;
      .links-wrap {
        width: $col2;
        margin-right: $main-margin;
        display: flex;
        align-items: center;
      }
    }
  }
  .rt-side {
    width: 100%;
    .links-wrap {
      position: relative;
      display: flex;
      width: 100%;
      justify-content: space-between;
      // margin-right: $grid-padding;
      .links-lt {
        display: flex;
        align-items: center;
        .link {
          margin-right: $main-margin;
        }
      }
      .links-rt {
        display: flex;
        align-items: center;
        margin-right: $grid-padding;
      }
    }
  }

  .logo-wrap {
    display: flex;
    align-items: center;
    height: $nav-height;
    &:hover {
      cursor: pointer;
    }
  }
  .logo {
      line-height: 0;
  }
  .post {
    background-color: $black;
    color: $white;
    &:hover {
      background-color: $icon-hover-color;
      color: $black;
      border: 2px solid $icon-hover-color;
    }
  }

}

// MOBILE
@media #{$mobile} { 
  .navbar {
    height: $nav-height-mobile;

    .lt-side { 
      width: 100%;
      .menu-wrap-2 {
        width: 100%;
        margin: 0;
        flex-direction: row-reverse;
        justify-content: space-between;
        .links-wrap {
          margin: 0;
          width: auto;
          padding: $main-margin-mobile;
        }
      }
    }
    .rt-side {
      display: none;
    }

    // .menu-wrap, .search-wrap {
    //     width: auto;
    // }
    // .lt-side {
    //   .menu-wrap {
    //     position: absolute;
    //     right: 0;
    //   }
    //   .logo-wrap {
    //     height: $nav-height-mobile;
    //   }
    //   .logo {
    //     margin-left: $main-margin-mobile;
    //   }
    // }
    // .rt-side {
    //   .search-wrap {
    //     position: absolute;
    //     right: 36px;
    //   }
    //   .signed-out, .signed-in {
    //     position: fixed;
    //     bottom: 0;
    //     left: 0;
    //     width: 100%;
    //     background-color: $black;
    //     display: flex;
    //     justify-content: flex-end;
    //     height: calc(#{$nav-height-mobile} + #{$main-margin-mobile});
    //     padding: 0 $main-margin-mobile $main-margin-mobile $main-margin-mobile;
    //     box-sizing: border-box;
    //     font-size: $p2;
    //     .button-text {
    //       color: $white;
    //     }
    //     p {
    //       margin: 0;
    //       color: $white;
    //       font-size: $p2;
    //     }
    //   }
    // }
  }
}

</style>